<template>
	<div>
		<!--  excel表格上传  -->
		<!-- <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple accept=".xlsx"
		 :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile">
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">
				将文件拖到此处，或
				<em>点击上传</em>
			</div>
			<div class="el-upload__tip" slot="tip">1次只能上传1个xls文件，且不超过500kb</div>
		</el-upload> -->
		<button @click="get()">点我</button>
		<!--  上传的excel表格预览  -->
		<div class="preview-excel">
			<el-table class="listTable_ele" :data="listTable" stripe height="250" style="width:100%">
				<el-table-column prop="name" label="姓名" width="200" align="center"/>
				<el-table-column prop="money" label="金额" width="200" align="center"/>
			</el-table>
		</div>
	</div>
</template>

<script>
	//import UploadFun from '../api/upload.js'
	// import XLSX from 'xlsx'
	export default {
		name: 'ccss',
		props: {
			msg: 'Upload'
		},
		data() {
			return {
				listTable: [
					{
					name: "test222",
					money: 1
			    	},
				] 
			};
		},
		methods: {
			get(){
				this.listTable.push({
					name: 'test111',
					money: 1
				});
				
			},
			//解析excel
			async uploadFile(params) {
				const _file = params.file;
				const fileReader = new FileReader();
				fileReader.onload = (ev) => {
					try {
						const data = ev.target.result;
						const workbook = XLSX.read(data, {
							type: 'binary'
						});
						for (let sheet in workbook.Sheets) {
							//循环读取每个文件
							const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
							//若当前sheet没有数据，则continue
							if (sheetArray.length == 0) {
								continue;
							}
							console.log("读取文件");
							console.log(sheetArray);
							for (let item in sheetArray) {
								let rowTable = {};
								//这里的rowTable的属性名注意要与上面表格的prop一致
								//sheetArray的属性名与上传的表格的列名一致
								rowTable.name = sheetArray[item].姓名;
								rowTable.money = sheetArray[item].金额;
								this.listTable.push(rowTable)
							}
						}
						console.log(this.listTable)
					} catch (e) {
						this.$message.warning('文件类型不正确！');
					}
				};
				fileReader.readAsBinaryString(_file);
				
			},
			//上传1个以上文件时弹窗提示错误
			exceed: function() {
				this.$message.error("最多只能上传1个xlsx文件");
			},
			//删除文件
			remove() {
				this.listTable = [];
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/ccss.vue